import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

function gtag(...args: any[]) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (consent !== 'granted') {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'granted');
    gtag('consent', 'update', { 'analytics_storage': 'granted' });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1a1a2e',
        color: '#e0e0e0',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        zIndex: 9999,
        fontSize: '14px',
        borderTop: '1px solid #333',
        flexWrap: 'wrap',
      }}
    >
      <span>
        This site uses cookies. By continuing use this site, you are agreeing to our use of cookies.{' '}
        <Link
          to="/cookies"
          style={{
            color: '#a8b4ff',
            textDecoration: 'underline',
          }}
        >
          Cookie Policy
        </Link>
      </span>
      <button
        onClick={handleAccept}
        style={{
          backgroundColor: 'transparent',
          color: '#ffffff',
          border: '1px solid #ffffff',
          padding: '6px 20px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 600,
          letterSpacing: '0.5px',
          textTransform: 'uppercase' as const,
          borderRadius: '2px',
          whiteSpace: 'nowrap',
        }}
      >
        Accept
      </button>
    </div>
  );
};

export default CookieConsentBanner;
